import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export interface UnsavedChangesDialogData {
  entityName?: string; // e.g., 'Capacity', 'Notes'
  hasValidationErrors?: boolean;
  validationErrorMessage?: string;
  /**
   * When true, the dialog never offers to save: it always shows a "Continue
   * Editing" primary button and hides any validation messaging. Used by flows
   * (e.g. the request wizard) where saving/creating is a deliberate action
   * taken from the main form, not this confirmation prompt.
   */
  continueEditingOnly?: boolean;
}

@Component({
  selector: 'app-unsaved-changes-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './unsaved-changes-dialog.component.html',
  styleUrls: ['./unsaved-changes-dialog.component.scss'],
})
export class UnsavedChangesDialogComponent {
  dialogRef = inject<MatDialogRef<UnsavedChangesDialogComponent>>(MatDialogRef);
  data = inject<UnsavedChangesDialogData>(MAT_DIALOG_DATA);

  constructor() {
    // Set defaults if no data provided
    this.data = this.data || {
      entityName: '',
      hasValidationErrors: false,
      validationErrorMessage: '',
    };
  }

  onCancel(): void {
    this.dialogRef.close('cancel');
  }

  onDiscard(): void {
    this.dialogRef.close('discard');
  }

  onSave(): void {
    this.dialogRef.close('save');
  }
}
